export default __webpack_public_path__ + "static/media/back.b1894b08.svg";